import { Modal, CustomTable, InputNumber } from 'medere-ui-framework'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { useState, useRef } from 'react'
import { useIntl } from 'react-intl'
import { axiosInstance } from '../App'

export default function InactiveUsersView() {
    const intl = useIntl()
    const customTableRef: any = useRef(null)
    const [inactiveUsers, setInactiveUsers] = useState<any>([])
    const [inputDays, setInputDays] = useState(60)
    const [convertAllModal, setConvertAllModal] = useState(false)
    function getInactiveUsers(offset: number, pageSize: number, params: any) {
        return axiosInstance.post(`/api/secured/inactiveusers/getAllInactiveUsers`, {
            offSet: offset,
            pageSize,
            filters: params.filterDTO,
            sortingFieldInfoList: params.multiSortMeta
        }, {
            params: {
                days: inputDays
            }
        }).then((response: any) => {
            return response.data
        })
    }

    function updateInactiveUsers() {
        axiosInstance.put('/api/secured/inactiveusers/updateInactiveUsers', {
            inactiveUserDTOList: inactiveUsers
        }, {
            params: {
            }
        }).then(() => {
            setInactiveUsers([])
            customTableRef.current.refreshTable();
        })
    }

    function convertAllActivesToInactives() {
        axiosInstance.put('/api/secured/inactiveusers/convertAllActivesToInactives', {}, {
            params: {
                days: inputDays
            }
        }).then(() => {
            setConvertAllModal(false)
            customTableRef.current.loadItemsRefresh()
        })
    }

    function lastDateColumn(rowData: any) {
        if (rowData.lastdate == null) {
            return <div>Ningun ingreso registrado</div>
        } else {
            const date = new Date(rowData.lastdate)
            return <div>{date.toLocaleDateString()}</div>
        }
    }


    function onSelectionChange(listOfSelectedUsers: any) {
        setInactiveUsers(listOfSelectedUsers.value)
    }


    function searchByDay() {
        customTableRef.current.loadItemsRefresh()
    }



    return (
        <div className='p-4 viewContainer'>
            <h2 className='text-2xl'>Inactividad de usuarios</h2>
            <div className='flex justify-content-between'>
                <h4 className='flex align-items-center'>Usuarios que no iniciaron sesion en los ultimos <InputNumber className='w-16 daysInactive mx-2' value={inputDays} onChange={(e: any) => {
                    setInputDays(e.target.value)
                }} /> dias </h4>
                <div>
                    <Button onClick={searchByDay} icon='pi pi-search' className='buttonMain' />
                </div>

            </div>


            <div className='px-4 flex flex-column ' style={{
                maxHeight: 'calc(100vh - 200px)',
                minHeight: '300px',
                flexGrow: 1,
            }}>
                <CustomTable idTable='tableInactiveUsers' getItems={getInactiveUsers} showGridlines className='crudTable editable-cells-table' filterRow ref={customTableRef} onSelectionChange={onSelectionChange} selectedItems={inactiveUsers} selectionMode='multiple'>
                    <Column field="firstname" header={intl.formatMessage({ id: 'firstname' })} className='column' filter />
                    <Column field="lastname" header={intl.formatMessage({ id: "lastname" })} className='column' filter />
                    <Column body={lastDateColumn} field='lastdate' header={intl.formatMessage({ id: "lastdate" })} className='column' />
                    <Column field='profile' header={intl.formatMessage({ id: "profile" })} className='column' filter />
                </CustomTable>
            </div>
            <div className='mt-4 flex align-items-center justify-content-end'>
                <h4 className='text-lg'>Pasar a inactivos:</h4>
                <div>
                    <Button onClick={updateInactiveUsers} disabled={inactiveUsers.length < 1} label="Seleccionados" icon='pi pi-save' className='buttonMain' />
                    <Button onClick={() => { setConvertAllModal(true) }} icon='' label='Todos' className='buttonMain' />
                </div>
            </div>

            <Modal visible={convertAllModal} setVisible={setConvertAllModal} header='Advertencia'>
                <h4 className='text-xl'>Está seguro que desea cambiar todos los usuarios a inactivos?</h4>
                <div className='flex flex-end'>
                    <Button label='Si' className='buttonMain' onClick={convertAllActivesToInactives} />
                    <Button label='No' className='buttonMain' onClick={() => { setConvertAllModal(false) }} />
                </div>
            </Modal>
        </div>
    )
}
